import {
  defaultSupportTicketSearchFieldKeys,
  supportTicketSearchFieldKeys,
} from "@redotech/effect-api-shared/schema/support-ticket-filters";
import type { RedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";

const SEARCH_FIELD_LABELS: Record<
  (typeof supportTicketSearchFieldKeys)[number],
  string
> = {
  customerName: "Customer name",
  customerEmail: "Customer email",
  customerPhone: "Customer phone",
  socialHandles: "Social handles",
  emailSubject: "Subject",
  messageContent: "Body",
  summary: "AI summary",
  ticketNumber: "Ticket number",
  orderNumber: "Order number",
};

/** Multiselect options for scoping which fields a support search targets. */
export const SUPPORT_TICKET_SEARCH_FIELD_OPTIONS: RedoListItem<string>[] =
  supportTicketSearchFieldKeys.map((key) => ({
    id: key,
    value: SEARCH_FIELD_LABELS[key],
    type: "text",
    text: SEARCH_FIELD_LABELS[key],
  }));

export const DEFAULT_SUPPORT_TICKET_SEARCH_FIELD_KEYS =
  defaultSupportTicketSearchFieldKeys;
